import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { TSortableColumn } from '../Components/GenericTable/types';
import { ICandidateSourcingPool } from './types';

export const candidatePoolTableColumn: TSortableColumn[] = [
  { id: 'id', label: 'ID', sortable: true, canToggle: true, enabled: true },
  { id: 'title', label: 'Title', sortable: true, canToggle: true, enabled: true },
  {
    id: 'candidate_count',
    label: 'Candidates',
    sortable: false,
    canToggle: true,
    enabled: true
  }
];

interface CandidatePoolTableRowsProps {
  column: TSortableColumn;
  item: ICandidateSourcingPool;
  tableHovered: boolean;
  dispatch?: any;
}

const CandidatePoolTableRows: React.FC<CandidatePoolTableRowsProps> = ({ column, item, tableHovered, dispatch }) => {
  const handleViewPool = () => {
    window.location.href = `/admin/candidate_sourcing/candidate_pools/${item.id}`;
  };

  switch (column.id) {
    case 'id':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewPool}>
            {item.id}
          </Typography>
        </TableCell>
      );
    case 'title':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewPool}>
            {item.title || `Pool #${item.id}`}
          </Typography>
        </TableCell>
      );
    case 'candidate_count':
      return (
        <TableCell>
          <Typography variant="body2">{item.candidate_count || 0}</Typography>
        </TableCell>
      );

    default:
      return <TableCell />;
  }
};

export default CandidatePoolTableRows; 
